import { LanguageTranslations } from '../config/language'

export interface CartItem {
  product_id: number
  uuid: string
  replace_name: any
  inputs: { [key: string]: string }
  product_name: string
  product_slug: string
  demo_name: string
  cover?: Cover
  cover_id: number | null
  default_replace_name: string
  product_type: 1 | 2
  image: string
  price: number
  quantity: number
  total: number
  language?: keyof LanguageTranslations
  discount: number
  gender?: string
  dedication?: string
  dedication_id?: number
  front_price?: number
  packaging?: {
    name: string
    price: number
  }
  product?:any
}

export interface Cover {
  id: number
  name: { ar: string; en: string }
  price: {
    amount: any
    currency: any
    symbol: any
  }
  description: string
  image: string
  created_at: Date
  updated_at: Date
  pivot: Pivot
}

export interface Pivot {
  product_id: number
  covers_id: number
}

export type initialStateType = {
  items: Array<CartItem>
  customer_id?: number | null
  address: any
  address_type: 'pickup_point' | 'home_delivery' | 'self_pickup'
  subtotal: number
  shipping_fee: number
  coupon: string | null
  coupon_type: 'shipping' | null
  currency: string
  coupon_percent: number
  discount_total: number
  total: number
  front_price?: number
  shipping_country?: string
  cloudprinter_info?: any
}

export const initialState: initialStateType = {
  customer_id: null,
  items: [],
  total: 0,
  subtotal: 0,
  address: null,
  address_type: 'self_pickup',
  coupon: null,
  coupon_type: null,
  currency: 'ILS',
  coupon_percent: 0,
  discount_total: 0,
  shipping_fee: 0,
  front_price: 0,
  cloudprinter_info: null
}

export type actionType =
  | { type: 'SET_CART'; payload: initialStateType }
  | { type: 'EMPTY_CART' }
  | { type: 'SET_CURRENCY'; payload: string }
  | {type: 'PATCH_CART'; payload: any}

export const CartReducer = (
  state: initialStateType,
  action: actionType
): initialStateType => {
  switch (action.type) {
    case 'SET_CART':
      return { ...state, ...action.payload }

    case 'PATCH_CART':
      return {
        ...state,
        ...action.payload,
      };

    case 'SET_CURRENCY':
      // console.log('[CartReducer] SET_CURRENCY payload:', action.payload)
      return { ...state, currency: action.payload }

    case 'EMPTY_CART':
      return { ...initialState }

    default:
      throw new Error(`Unhandled action type: ${action}`)
  }
}
